module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTG+GTHdLkRtbnFtbnG+GTG+GTG8vsCAgoW8vsD0kAy8vsBtbnHe7jLCAAAAE3RSTlMAYL//ACDP7///AIAQ//8A/4CfAteF4QAAAM5JREFUeAHt1tGKgzAQheEkx0SNu7X6/g/bICI7yxHsWDoi+W/m7oOJRnS7+YBS8M2xXMOLCWspnoFii602noAS/pT0kAfQrQHwaihIKKghSAgV0h+2/vGbvZD8iphe2pL2M0LqS/loLu/3cWgAaXh/tR/QlFAn0kH55pDMDFr7LT2WtlkaZW7c7+ZQLl0QItlDzyWyWoWWrgnJLCF52Nus0PUhmgKamDMpIIM/NhuoQhWq0Nz/a1ZAzCmSCupJhpDc6/h2jjgqydG1eN+BXlufvbtuqx/2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f68f.png
// module id = 1257
// module chunks = 0